import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { getProductTypeByAutocompleteResultItem, getSourceIdByAutocompleteResultItem } from '../utils/usageTracker';
export function useTrackAutocompleteSearchResultEvent({
  resultCount,
  searchTerm
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const getAutocompleteSearchResultEventProps = useCallback((item, resultIndex) => {
    return Object.assign({
      companyName: item.providerName,
      componentType: 'AutocompleteItem',
      listingId: item.resultType === 'COLLECTION' ? item.collectionId : item.listingId,
      resultCount,
      resultIndex,
      resultType: String(item.resultType),
      search: searchTerm,
      slug: item.slug,
      sourceId: getSourceIdByAutocompleteResultItem(item),
      type: getProductTypeByAutocompleteResultItem(item),
      value: item.resultType === 'QUERY' ? item.term : undefined
    }, item.resultType === 'COLLECTION' ? {
      category: item.slug,
      collectionId: item.collectionId,
      screen: 'collection search results'
    } : {});
  }, [resultCount, searchTerm]);
  const trackAutocompleteSearchResultClickedEvent = useCallback((item, resultIndex) => {
    trackMarketplaceEvent(getSearchResultClickedEvent(getAutocompleteSearchResultEventProps(item, resultIndex)));
  }, [getAutocompleteSearchResultEventProps, trackMarketplaceEvent]);
  return {
    getAutocompleteSearchResultEventProps,
    trackAutocompleteSearchResultClickedEvent
  };
}